<template>
  <div class="love-you-club-header">
    <!--    <h2 class="love-you-club-header__title">-->
    <!--      {{ item?.name }}-->
    <!--    </h2>-->
    <DefTitle :result="2">
      <h2>
        {{ item?.name }}
      </h2>
    </DefTitle>
    <p class="love-you-club-header__text" v-html="item?.previewText"></p>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { useStore } from '@store';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';

const { getters } = useStore();
const { result } = defineProps(['result']);
const item = computed(() => getters['club/getItem']);
</script>

<script>
export default {
  name: 'LoveYouClubHeader',
};
</script>

<style lang="scss" scoped>
.love-you-club-header {
  margin-bottom: 24px;
  :deep(.def-title.def-title-2) {
    /*font-weight: 600;*/
    /*font-size: rem(16);*/
    letter-spacing: 0.04em;
    text-transform: uppercase;
    /*margin-bottom: 8px;*/
    @include point-md {
      font-size: rem(24);
    }
  }
  &__text {
    color: black;
    font-size: rem(12);
    line-height: 130%;
    @include point-md {
      font-size: rem(14);
    }
  }
}
</style>
